import HttpService from "../http/http.service";
import {
	TwilioConversationMessagesRequest,
	TwilioSmsPostRequest,
	TwilioTokenRequest,
} from "../../models/endpoints/twilio-endpoint.model";
import { Sms } from "../../models/entities/sms.model";

const httpService = new HttpService(process.env.REACT_APP_API_TWILIO!);

// Twilio endpoints
export const TwilioEndpointsService = {
	getConversationsAccessToken: async (request: TwilioTokenRequest): Promise<{ token: string }> =>
		httpService.get("/twilio/access-token/conversations", request),
	sendCareMessage: async (request: TwilioConversationMessagesRequest): Promise<void> =>
		httpService.post(`/twilio/communications/message/participant`, request),
	getConversation: async (participantId: string): Promise<string> =>
		httpService.get(`/twilio/communications/${participantId}`),
	getSmsByParticipant: async (participantId: string): Promise<Sms[]> =>
		httpService.get(`/twilio/communications/sms/${participantId}`),
	sendSmsToParticipant: async (request: TwilioSmsPostRequest): Promise<Sms> =>
		httpService.post(`/twilio/communications/sms/coach`, request),
};
